import i18n from '../i18n';
import spanish from '../locales/report.es.json';

// Translate only known UI/structured values. Names and authored clinical notes stay verbatim.
const normalize = (value: string) => value.replace(/([a-z])([A-Z])/g, '$1 $2').trim().toLowerCase();
const keys = new Map(Object.keys(spanish).map((key) => [normalize(key), key]));

export const reportText = (value: string, variables: Record<string, string | number> = {}): string =>
  i18n.t(keys.get(normalize(value)) ?? value, {
    ...variables,
    ns: 'report', keySeparator: false, nsSeparator: false, defaultValue: value,
  });

export const reportLocale = (): string => i18n.language?.startsWith('es') ? 'es-US' : 'en-US';

export const reportAge = (value?: string): string => value
  ? value.replace(/\b(years?|months?|weeks?|days?)\b/gi, (unit) => reportText(unit))
  : reportText('Age not provided');

export const reportParticipantName = (value: string, isStudy: boolean, studyId?: string): string => {
  if (!isStudy) return value;
  if (studyId) return value && value !== 'Study Participant'
    ? value
    : `${reportText('Study Participant')} ${studyId}`;
  const participant = value.match(/^Participant (.+)$/);
  return participant ? reportText('Participant {{id}}', { id: participant[1] }) : reportText(value);
};
